<nb-card [nbSpinner]="loading" nbSpinnerStatus="danger" nbSpinnerSize="giant">
  <app-datatable
    [columns]="columns"
    [rows]="roomChampion"
    [searchable]="searchable"
  >
  </app-datatable>
</nb-card>
